export enum ApiPath {
  AuthLogin = 'auth/login',
  AuthTemporaryToken = 'auth/temporary-token',
  Assets = 'assets',
  Sites = 'sites',
  Site = 'sites/:id',
  AssetsAssign = 'assets/assign',
  Asset = 'assets/:id',
  AssetPacks = 'asset-packs',
  AssetAlerts = 'assets/:id/alerts',
  AssetAlert = 'assets/alerts/:id',
  AssetImage = 'assets/:id/image',
  AssetDuplicate = 'assets/:id/duplicate',
  AssetPendingTransaction = 'assets/:guid/pending-transaction',
  AssetCategories = 'assets/categories',
  AssetSubcategories = 'assets/subcategories',
  Customers = 'customers',
  Customer = 'customers/:id',
  Users = 'users',
  User = 'users/:id',
  UserPassword = 'users/:id/password',
  Transactions = 'transactions',
  Transaction = 'transactions/:id',
  Notifications = '/notifications',
  NotificationsStatusRead = '/notifications/status/read',

  DashboardIssuedChart = 'assets/dashboard/issued-chart',
  DashboardLocations = 'assets/dashboard/locations',
  DashboardStatistics = 'assets/dashboard/statistics',
  DashboardUnassignedAssets = 'assets/dashboard/unassigned-assets',
  DashboardReturnedAssets = 'assets/dashboard/returned-assets',
  DashboardGateQuestions = 'assets/dashboard/gate-questions',
  DashboardTransactions = 'assets/dashboard/transactions',
  DashboardTransfers = 'assets/dashboard/transfers',

  WhatsAppPreferences = 'whatsapp/preferences',
  WhatsAppPreference = 'whatsapp/preferences/:phoneNumber',
  EntityAliases = 'entity-aliases',
  EntityAlias = 'entity-aliases/:id',
  EntityAliasConflicts = 'entity-aliases/conflicts',
  EntityAliasPreview = 'entity-aliases/preview',
  EntityAliasRebuild = 'entity-aliases/rebuild',
}
